import React from "react"
import { CollaboratorStatus } from "../../../../../../Models/API/CollaboratorModel"
import { NoData } from "../../../../../Common/NoData/NoData"

export function dashOrPercent(value?: number) {
    return value === undefined ? <NoData /> : `${Math.round(value * 100)}%`
}

export function invertStatus(status: CollaboratorStatus) {
    switch (status) {
        case CollaboratorStatus.ACTIVE:
            return CollaboratorStatus.INACTIVE
        case CollaboratorStatus.INACTIVE:
            return CollaboratorStatus.ACTIVE
        default:
            // don't change what we don't expect
            return status
    }
}
